module.exports = __webpack_public_path__ + "img/portrait-050.6e0d6598.jpg";